import { LS_MUTED_USERS } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed } from 'vue'

const state = useLocalStorage(LS_MUTED_USERS, [])

export default function () {
  const mutedUsers = computed(() =>
    isArray(state.value) ? state.value : JSON.parse(state.value)
  )

  function isUserMuted(nameId) {
    return computed(() => mutedUsers.value.some((u) => u.name_id === nameId))
  }

  function addMutedUser(user) {
    const newUserArray = [...mutedUsers.value, user]
    setMutedUsers(newUserArray)
  }

  function removeMutedUser(user) {
    const newUserArray = mutedUsers.value.filter((u) => u.id !== user.id)
    setMutedUsers(newUserArray)
  }

  function clearMutedUsers() {
    setMutedUsers([])
  }

  function setMutedUsers(users) {
    state.value = users
  }

  return {
    clearMutedUsers,
    removeMutedUser,
    setMutedUsers,
    addMutedUser,
    isUserMuted,
    mutedUsers,
  }
}
